const BASE_ACTION_CONSTANT = 'app/tnc';

export const GET_TNC = `${BASE_ACTION_CONSTANT}/GET_TNC`;
export const SAVE_TNC = `${BASE_ACTION_CONSTANT}/SAVE_TNC`;
export const HIDE_PRODUCT_TNC = `${BASE_ACTION_CONSTANT}/HIDE_PRODUCT_TNC`;
export const HIDE_SIGNUP_TNC = `${BASE_ACTION_CONSTANT}/HIDE_SIGNUP_TNC`;
export const HIDE_SAR_TNC = `${BASE_ACTION_CONSTANT}/HIDE_SAR_TNC`;
export const HIDE_SAQA_TNC = `${BASE_ACTION_CONSTANT}/HIDE_SAQA_TNC`;

export const UPDATE_PRODUCT_TNC = `${BASE_ACTION_CONSTANT}/UPDATE_PRODUCT_TNC`;
export const UPDATE_SIGNUP_TNC = `${BASE_ACTION_CONSTANT}/UPDATE_SIGNUP_TNC`;
export const UPDATE_SAR_TNC = `${BASE_ACTION_CONSTANT}/UPDATE_SAR_TNC`;
export const UPDATE_SAQA_TNC = `${BASE_ACTION_CONSTANT}/UPDATE_SAQA_TNC`;
export const INVALIDATE_TOKEN = `${BASE_ACTION_CONSTANT}/INVALIDATE_TOKEN`;

export const INVALIDATE_TOKEN_URL = {
  url: '/common/user/logout',
  method: 'POST',
};

export const TNC_TYPE = {
  SIGNUP: 'SIGNUP',
  PRODUCT: 'PRODUCT',
  SAR: 'SAR',
  SAQA: 'SAQA',
};
